import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Contatti from "@/pages/Contatti";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TerminiDiVendita from "@/pages/TerminiDiVendita";
import DirittoDiRecesso from "@/pages/DirittoDiRecesso";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const ScrollAndTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/" && !window.location.hash) window.scrollTo(0, 0);
    if (pathname === "/") document.title = "MP Coaching — Focus. Metodo. Costanza.";
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollAndTitle />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/termini-di-vendita" element={<TerminiDiVendita />} />
          <Route path="/diritto-di-recesso" element={<DirittoDiRecesso />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="top-center" theme="dark" richColors />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
